import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {BooleanNode} from "#template/nodes/boolean/boolean-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"

import type {LodTypeValue} from "#template/value-types"

export type LodTypeParameters = {
    lodType: LodTypeValue
}

const lodTypeDefinition: TemplateNodeDefinition<LodTypeParameters> = {
    nodeClass: "LodType",
    validation: {
        parameters: z.object({
            lodType: z.enum(["web", "ar", "pathTraced"]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class LodType extends BooleanNode<LodTypeParameters> {
    public override get definition() {
        return lodTypeDefinition
    }

    public override evaluate(_scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<boolean | null> {
        const {templateContext} = evaluator
        return templateContext.lodType === this.parameters.lodType
    }
}
